
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  import SUBSCRIPTION_NOTIFICATIONS_COUNT from "@/apollo/notifications/SubscriptionNotificationsCount.gql";
  import SUBSCRIPTION_GET_NOTIFICATIONS from "@/apollo/notifications/SubscriptionGetNotifications.gql";
  import TOGGLE_NOTIFICATION_SHOWN from "@/apollo/notifications/ToggleNotificationShown.gql";

  import NotificationsList from "@/components/notification/NotificationsList.vue";
  import BellIcon from "@/components/icons/BellIcon.vue";
  import { ApolloQueryResult } from "node_modules/apollo-client";
  import { Notification_Aggregate } from "@/generated/graphql";
  import { Notification } from "@/generated/graphql";

  @Component({
    components: {
      NotificationsList,
      BellIcon,
    },
    apollo: {
      $subscribe: {
        notifications: {
          query: SUBSCRIPTION_NOTIFICATIONS_COUNT,
          result(response: ApolloQueryResult<{ notification_aggregate: Notification_Aggregate }>) {
            this.newNotificationsCount = response.data.notification_aggregate.aggregate!.count;
          },
          variables() {
            return {
              userId: this.currentUserId,
            };
          },
        },
        notificationsUnread: {
          query: SUBSCRIPTION_GET_NOTIFICATIONS,
          variables() {
            return { read: false, userId: this.currentUserId };
          },
          result({ data }: { data: { notifications: Notification[] } }) {
            if (this.notificationsUnread.length === 0) {
              this.notificationsUnread = data.notifications;
              return;
            }

            const newNotifications = data.notifications.filter((notification) => {
              const oldNotification = this.notificationsUnread.some(
                (notificationShown: Notification) => notificationShown.id === notification.id
              );
              if (oldNotification) {
                return;
              }
              return notification;
            });
            this.notificationsUnread = [...newNotifications, ...this.notificationsUnread!];
          },
        },
      },
    },
  })
  export default class NotificationDropdown extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;

    listShown: boolean = false;
    newNotificationsCount: number = 0;
    notificationsUnread: Notification[] = [];

    get notificationsCount(): string {
      if (this.newNotificationsCount > 9) {
        return "9+";
      }
      return String(this.newNotificationsCount);
    }

    async toggleDropdown() {
      this.listShown = !this.listShown;
    }

    get isNewNotificationsExist(): boolean {
      return this.newNotificationsCount > 0;
    }

    get iconStyle(): Object {
      return { notifications__icon: this.isNewNotificationsExist };
    }

    get toggleStyle(): Object {
      return { "iconClicked": this.listShown};
    }

    @Watch("notificationsUnread")
    onNotificationsChange(): void {
      if (this.notificationsUnread) {
        this.notificationsUnread.forEach(async (notification) => {
          if (!notification.shown) {
            await this.$apollo.mutate({
              mutation: TOGGLE_NOTIFICATION_SHOWN,
              variables: {
                id: notification.id,
              }
            });
            this.$root.$emit('notify', [notification.message, "Jobbliss", notification.link]);
            notification.shown = !notification.shown;
          }
        });
      }
    }

    created(): void {
      if(this.isNewNotificationsExist) {
        this.$root.$emit('notify', ["You have some unread notifications", "Jobbliss",""]);
      }
    }
  }
